import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { SharedService } from '../../../../../shared/shared.service';
import { InvoiceService } from '../../invoices.service';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-invoices-print',
  templateUrl: './invoices-print.component.html',
  styleUrls: ['./invoices-print.component.css']
})
export class InvoicesPrintComponent implements OnInit {
  sessionId = sessionStorage.getItem('com-session-id');


  constructor(
    private httpclient: HttpClient,
    public sharedService: SharedService,
    public invoice: InvoiceService,
    private sanitizer: DomSanitizer
  ) { }

  src: any = this.sanitizer.bypassSecurityTrustResourceUrl(`https://www.incasu.co.za`)

  ngOnInit() {
    
  }
}
